<template>
  <div class="form-header font-weight-bold text-blue-500 font-underline">{{ props.text }}</div>
</template>

<script setup lang="ts">
type Props = {
  text?: string
}

const props = withDefaults(defineProps<Props>(), {
  text: ''
})
</script>

<style lang="scss">
div.form-header {
  text-decoration-color: var(--bs-primary);
}
</style>
